
<template>

	<main v-if="fetcher.initialized">

		<div class="page-header" :class="{ 'active' : showPageHeader }">

			<div class="container-fluid">
				<div class="page-title">Start</div>
			</div>

		</div>

		<div class="page-body start" style="min-height: 900px;">

			<div class="container-fluid">

                <div class="branding">
                    <img src="/images/company-portal/logo.svg">
                </div>

				<h1>Hej, {{ manager.name }}</h1>
				<p style="max-width: 600px;">Välkommen till företagsportalen. Här hittar du allt du behöver för att hålla koll på behandlingar, anställda  och kostnader.</p>

	        </div>

        	<div class="card-viewport mt-12">
        		<div class="card-container two-cards">
        			<div class="container-fluid">
				        <div class="row g-3 g-md-5">
				        	<div class="col-12 col-md-12 col-lg-8 mb-6 mb-md-0">
				        		<div class="card">
                                    <div class="pre-line">Abonnemang</div>
                                    <h2 v-if="contractInfo">
                                        {{ contractInfo.subscription.name_public }}
                                    </h2>
                                    <p class="pre-line text-warning" v-if="active_contract && active_contract.ends_at && !pending_contract">Avtalet är uppsagt och utgår {{ active_contract.ends_at }}</p>
                                    <p class="pre-line text-warning" v-if="previous_contract && !active_contract">Avtalet avslutades {{ previous_contract.ends_at }}</p>
                                </div>
				        	</div>
				        	<div class="col-12 col-md-12 col-lg-8 mb-6 mb-md-0">
				        		<div class="card">
				        			<div class="pre-line">Länkar</div>
						        	<p>
						        		<a :href="app_url" target="_blank">
                                            App för anställda <img class="link-icon" src="/images/company-portal/icon-new-window.svg">
                                        </a>
                                        <br>
						        		<a :href="company.registration_url" target="_blank" v-if="company.open_registration_is_active">
                                            Registreringssida <img class="link-icon" src="/images/company-portal/icon-new-window.svg">
                                        </a>
						        	</p>
						        </div>
				        	</div>
				        </div>
				    </div>
			    </div>
		    </div>

		    <div class="container-fluid">

		        <div class="row mt-10">
		        	<div class="col-24 col-md-12 mb-6 mb-md-0">
		        		<div class="card image">

                            <picture>
                              <source srcset="/images/company-portal/card-image1.webp" type="image/webp">
                              <source srcset="/images/company-portal/card-image1.jpg" type="image/jpg"> 
                              <img src="/images/company-portal/card-image1.jpg">
                            </picture>

		        			<div class="card-container">
			        			<h2>Klassisk massage</h2>
			        			<p>Ibland även kallad Svensk klassisk massage – är en behandlingsform där man bearbetar mjukdelsvävnaderna för att mjuka upp och komma till rätta med stelhet, smärta och ömhet. <a href="https://halsoresurs.se/om-massage/" target="_blank">Läs mer ></a></p>
			        		</div>
				        </div>
		        	</div>
		        	<div class="col-24 col-md-12 mb-6 mb-md-0">
		        		<div class="card image">

                            <picture>
                              <source srcset="/images/company-portal/card-image2.webp" type="image/webp">
                              <source srcset="/images/company-portal/card-image2.jpg" type="image/jpg"> 
                              <img src="/images/company-portal/card-image2.jpg">
                            </picture>

		        			<div class="card-container">
			        			<h2>Våra massörer</h2>
			        			<p>Du ska vara säker på att få behandlingar av en kunnig och lyhörd massör som lyssnar till dina behov och önskemål. Alla våra massörer är utbildade och diplomerade massörer eller certifierade massageterapeuter.</p>
			        		</div>
				        </div>
		        	</div>
		        </div>

	        </div>

	    </div>

	</main>

</template>

<script>
import scrollMixin from '../../shared/mixins/scrollMixin'
import fetcher from '../../shared/mixins/fetcher'
import { activeContract, pendingContract, previousContract } from '../../shared/methods/contract-filter'

export default {

    mixins: [
        scrollMixin,
        fetcher
    ],

    data () {
        return {
            manager: null,
            company: null,
            contracts: [],
            app_url: null,
            active_contract: null,
            previous_contract: null,
            pending_contract: null,
            fetcher: {
                autoFill: [
                    'manager',
                    'company',
                    'active_contract',
                    'previous_contract',
                    'pending_contract',
                    'contracts',
                    'app_url'
                ]
            }
        }
    },

    computed: {
        fetcherUrl () {
            return '/data/dashboard'
        },
        contractInfo () {
            if (this.active_contract) {
                return this.active_contract
            } else if (this.pending_contract) {
                return this.pending_contract
            } else if (this.previous_contract) {
                return this.previous_contract
            }
        },
    },

    methods: {

    	activeContract: activeContract,

        pendingContract: pendingContract,

        previousContract: previousContract

    }
}
</script>
